export default "__VITE_ASSET__NHz$5eL9__"